/* eslint-disable */
import axios from 'axios';

export default {
    name: 'basketPage',
    props: {
        msg: String
    },
    data() {
        return {
            basket: [],
            basketService: [],
            service: [],
            debounceTimer: null
        }
    },
    computed: {
        allSum_FORMATED() {
            let result = 0;
            for (let key in this.basket) {
                result = result + (this.basket[key]['QUANTITY'] * this.basket[key]['PRICE']);
            }
            return result.toFixed(2).replace(/\.?0+$/, '') + ' ₽';
        },
        allWeight_FORMATED() {
            let result = 0;
            for (let key in this.basket) {
                result = result + (this.basket[key]['QUANTITY'] * this.basket[key]['WEIGHT']);
            }
            return result.toFixed(2).replace(/\.?0+$/, '') + ' кг.';
        },

        countProduct() {
            return this.basket.length
        }
    },
    watch: {
        basket: {
            handler(newValue, oldValue) {
                // Проверка изменения количества товара
                newValue.forEach((newItem, index) => {
                    const oldItem = oldValue[index];
                    if (oldItem && newItem.QUANTITY !== oldItem.QUANTITY) {
                        console.log(`Количество товара с ID ${newItem.ID} изменилось с ${oldItem.QUANTITY} на ${newItem.QUANTITY}`);
                        // Здесь можно добавить дополнительную логику, если необходимо
                    }
                });
            },
            immediate: true,
            deep: true
        },
    },
    methods: {
        onQuantityChange(index) {
            this.updatevalueDebounced(index, 'input');
        },
        minus: function (index) {
            if (this.basket[index].QUANTITY > 1) {
                this.basket[index].QUANTITY--;

            }
            this.updatevalueDebounced(index, 'minus');
        },
        plus: function (index) {
            this.basket[index].QUANTITY++;
            this.updatevalueDebounced(index, 'plus');

        },
        updatevalueDebounced: function (index, type) {
            clearTimeout(this.debounceTimer);
            let _this = this;
            this.basket[index].SUM = (this.basket[index].QUANTITY * this.basket[index].PRICE).toFixed(2).replace(/\.?0+$/, '');

            this.debounceTimer = setTimeout(function () {
                _this.updatevalue(index, type);
            }, 1000); // Задержка в 1 секунду
        },
        updatevalue: function (index, type) {

            let item = this.basket[index];
            let _this = this;
            let data = new FormData();
            data.append('id', item.ID);
            data.append('product_id', item.PRODUCT_ID);
            data.append('quantity', item.QUANTITY);
            data.append('type', type);

            axios({
                    method: 'post',
                    url: '/bitrix/services/main/ajax.php?action=metall:core.basket.add',
                    data: data
                }
            )
                .then(response => {
                    _this.basket = response.data.data['BASKET'];


                }).catch();
        },
        deleteitem: function (index) {
            let item = this.basket[index];
            this.basket.splice(index, 1);

            let data = new FormData();
            data.append('id', item.ID);
            data.append('product_id', item.PRODUCT_ID);

            axios({
                    method: 'post',
                    url: '/bitrix/services/main/ajax.php?action=metall:core.basket.del',
                    data: data
                }
            ).then(response => {
            }).catch();

        },
        getBasket: function () {//получаем товары из корзины пользователя
            var _this = this;
            axios.get('/bitrix/services/main/ajax.php?action=metall:core.basket.list')
                .then(response => {
                    _this.basket = response.data.data['BASKET'];
                    _this.service = response.data.data['SERVICE'];
                    for (let index in _this.service) {
                        if (_this.service[index].IN_BASKET == true) {
                            _this.basketService.push(this.service[index].ID)
                        }
                    }
                }).catch();

        },


        addService: function (index) {
            this.service[index].IN_BASKET = true;
            this.basketService.push(this.service[index]);

            let data = new FormData();
            data.append('strServiceId', this.service[index].ID);
            axios({
                    method: 'post',
                    url: '/bitrix/services/main/ajax.php?action=metall:core.basket.addService',
                    data: data
                }
            ).then(response => {
            }).catch();

        },
        deleteService: function (index) {
            let _this = this;
            this.service[index].IN_BASKET = false;

            let elementToRemove = this.basketService.find(item => item === _this.service[index].ID);

            if (elementToRemove) {
                let indexToRemove = this.basketService.indexOf(elementToRemove);
                this.basketService.splice(indexToRemove, 1);

                let data = new FormData();
                data.append('idService', this.service[index].ID);
                axios({
                        method: 'post',
                        url: '/bitrix/services/main/ajax.php?action=metall:core.basket.delService',
                        data: data
                    }
                ).then(response => {
                }).catch();

            }

        },
        linkChecked: function () {
            //Добавляем услуги в корзину которые были добавлены в заказ
            let idServiceInBasket = [];
            for (let index in this.service) {
                if (this.service[index].IN_BASKET == true) {
                    idServiceInBasket.push(this.service[index].ID)
                }
            }

            let data = new FormData();
            data.append('strServiceId',idServiceInBasket);

            axios({
                    method: 'post',
                    url: '/bitrix/services/main/ajax.php?action=metall:core.basket.addService',
                    data: data
                }
            ).then(response => {
                //Переходим на страницу оформления
                location.href = '/order/';
            }).catch();

        },
    },
    created() {
        this.getBasket();
    }
}
